import type { TFunction } from 'i18next';

import { CoverageHoursEntry } from './useCoverageHours';

export type CoverageHoursDeleteConfirmViewModel = {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
};

export function createCoverageHoursDeleteConfirmViewModel(
  entry: Pick<CoverageHoursEntry, 'category' | 'issue'>,
  t: TFunction
): CoverageHoursDeleteConfirmViewModel {
  return {
    title: t(
      'web.admin.serviceRequest.settings.coverageHours.delete.confirmTitle'
    ),
    message: t(
      'web.admin.serviceRequest.settings.coverageHours.delete.confirmMessage',
      {
        category: entry.category,
        issue:
          entry.issue ??
          t('web.admin.serviceRequest.settings.coverageHours.create.none'),
      }
    ),
    confirmText: t(
      'web.admin.serviceRequest.settings.coverageHours.delete.confirmButton'
    ),
    cancelText: t(
      'web.admin.serviceRequest.settings.coverageHours.delete.cancelButton'
    ),
  };
}
